import { EditOutlined } from "@mui/icons-material";
import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Radio,
  TimePicker,
  Modal,
  Checkbox,
  Switch,
  Space,
} from "antd";
import dayjs from "dayjs";
import InReview from "molecules/InReview";
import SelectTable from "molecules/SelectTable";
import FormModal from "organisms/FormModal";
import StepsProgress from "organisms/StepsProgress";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getLocations,
  getShiftList,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import styled from "styled-components";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";

const StyledModal = styled(Modal)`
  .color-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 16px 0;
  }

  .circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .circle.active {
    border: 2px solid #000;
  }

  .tick {
    font-size: 14px;
    color: #000;
  }

  .preview-box {
    margin-top: 16px;
    padding: 20px;
    text-align: center;
    font-weight: bold;
    border-radius: 8px;
    font-size: 18px;
  }

  .circle.disabled {
    pointer-events: none;
    opacity: 0.4;
  }
`;

const StyledButton = styled(Button)`
  background: #26a4ff;
  border-radius: 5px;
  color: #ffffff;
  width: 100px;
  margin: 5px;
`;

const AddShift = () => {
  const history = useHistory();
  const location = useLocation();
  const shiftColors = location?.state?.shiftColors || [];
  const departmentList = useSelector(getAllDepartmentList);
  const shiftList = useSelector(getShiftList);
  const locationList = useSelector(getLocations);
  const userInfo = useSelector(getUserInfo);
  const ClientId = useSelector(getClientid);
  const userList = useSelector(getUserList);
  console.log("shiftList", shiftList);

  const colors = [
    "#C5F3F9",
    "#A3E7F2",
    "#D1F4E8",
    "#FCD9F4",
    "#F9D3D3",
    "#E9D1FD",
    "#DAD7FE",
    "#FFECA9",
    "#FFEDC2",
    "#FFD3A3",
    "#FFCFB3",
    "#D8E9FF",
    "#C3E0C7",
    "#A6E3A1",
    "#8EE58C",
    "#78D67F",
    "#FFD1D1",
    "#FFADAD",
    "#FDE8E8",
    "#C3C3C3",
    "#F3F3F3",
    "#D3E5FF",
    "#FFBC99",
    "#FFA37B",
    "#FFEC99",
  ];

  const [step, setStep] = useState(0);
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [titleColor, setTitleColor] = useState(
    colors.find((color) => !shiftColors?.includes(color)) || colors[0]
  );
  const [selectedColor, setSelectedColor] = useState(titleColor);
  const [selectAllDepartmentChecked, setSelectAllDepartmentChecked] =
    useState(false);
  const [selectDepartmentId, setSelectDepartmentId] = useState([]);
  const [openDepartmentModal, setOpenDepartmentModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedLocationId, setSelectedLocationId] = useState([]);

  const showConfirm = (values) => {
    Modal.confirm({
      title:
        "Remember, holidays are counted as working days for the employees on this shift.",

      okText: "Okay, Include",
      cancelText: "Don't Include",
      okButtonProps: {
        loading: loader,
      },
      onOk: async () => {
        form.setFieldValue("isholiday", "yes");
      },
      onCancel: async () => {
        form.setFieldValue("isholiday", "no");
      },
    });
  };

  const [formValues, setFormValues] = useState({
    shifttitle: "",
    shiftcode: "",
    starts: null,
    ends: null,
    status: "active",
    isholiday: "no",
    isweekend: "allsaturdayandsunday",
  });
  const onFinish = async () => {
    setLoader(true);
    const finduser = userList?.find((user) => user.userid === userInfo?.userid);

    const { code } = await CALL_API(`add-shift/${ClientId}`, "post", {
      shifttitle: formValues.shifttitle,
      shiftcode: formValues.shiftcode,
      starts: dayjs(formValues.starts),
      ends: dayjs(formValues.ends),
      status: formValues.status,
      isholiday: formValues.isholiday,
      isweekend: formValues.isweekend,
      location: selectedLocationId,
      department: selectDepartmentId,
      color: titleColor,
      createduser: userInfo?.name,
      ceratedemployeeid: finduser?.employeeid,
      starttime: formValues.starts.format("HH:mm"),
      endtime: formValues.ends.format("HH:mm"),
    });
    if (code === STATUS_CODE.SUCCESS) {
      setLoader(false);
      history.push("/shift");
    }
  };

  const filterLocationList = locationList?.filter(
    (item) => item?.login_from_anywhere !== 1
  );

  const stepdata = [
    { id: 1, title: "Basic" },
    // { id: 2, title: "Department" },
    // { id: 3, title: "Location" },
    { id: 2, title: "Review" },
  ];

  const departmentcolumns = [
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "department_id",
      key: "department_id",
      width: "10%",
      align: "center",
      render: (department_id) => {
        return (
          <Switch
            size="small"
            checked={
              selectAllDepartmentChecked ||
              selectDepartmentId.includes(department_id)
            }
            onChange={(checked) => getDepartmentId(department_id, checked)}
          />
        );
      },
    },
  ];

  const getDepartmentId = (department_id, checked) => {
    const newDepartmentId = checked
      ? [...selectDepartmentId, department_id]
      : selectDepartmentId.filter((item) => item !== department_id);
    setSelectDepartmentId(newDepartmentId);
  };

  const handleSelectAllDepartment = (e) => {
    const checked = e.target.checked;
    setSelectAllDepartmentChecked(checked);
    const allDepartmentIds = departmentList.map((item) => item.department_id);
    setSelectDepartmentId(checked ? allDepartmentIds : []);
  };

  const locatincolumns = [
    {
      title: "Location Name",
      dataIndex: "location_name",
      key: "location_name",
      width: "10%",
    },
    {
      title: "Access Level",
      dataIndex: "location_id",
      key: "location_id",
      width: "10%",
      align: "center",
      render: (location_id) => {
        return (
          <Switch
            size="small"
            checked={
              selectAllChecked || selectedLocationId.includes(location_id)
            }
            onChange={(checked) => getLocationId(location_id, checked)}
          />
        );
      },
    },
  ];

  const getLocationId = (location_id, checked) => {
    const newLocationId = checked
      ? [...selectedLocationId, location_id]
      : selectedLocationId.filter((item) => item !== location_id);
    setSelectedLocationId(newLocationId);
  };

  const handleSelectAllLocation = (e) => {
    const checked = e.target.checked;
    setSelectAllChecked(checked);
    const allLocationIds = filterLocationList.map((item) => item.location_id);
    setSelectedLocationId(checked ? allLocationIds : []);
  };

  const weekendOptions = [
    { label: "All Saturdays and Sundays", value: "allsaturdayandsunday" },
    { label: "All Saturdays", value: "allsaturdays" },
    { label: "All Sundays", value: "allsundays" },
    { label: "All Days", value: "alldays" },
    { label: "No Weekends", value: "noweekends" },
  ];

  useEffect(() => {
    setSelectAllChecked(
      selectedLocationId.length === filterLocationList.length
    );
    setSelectAllDepartmentChecked(
      selectDepartmentId.length === departmentList.length
    );
  }, [selectedLocationId, locationList, selectDepartmentId, departmentList]);

  return (
    <div>
      <label
        className="bg-transparent border-0 mb-3 text-left styled-cursor"
        onClick={() => {
          history?.push("/shift");
        }}
      >
        Shift <ArrowForwardIosIcon className="px-1" />
      </label>{" "}
      <b className=" pb-0 pt-1">Add Shift</b>
      <StepsProgress stepdata={stepdata} title="Add Shift" step={step} />
      {step === 0 && (
        <Form
          form={form}
          name="AddEditShift"
          layout="vertical"
          initialValues={formValues}
          onFinish={(values) => {
            setFormValues(values);
            setStep(1);
          }}
        >
          <Row gutter={12}>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <Form.Item
                label="Shift Title"
                name="shifttitle"
                style={{ flex: 1 }}
                rules={[
                  {
                    required: true,
                    message: "Please enter Shift Title",
                  },
                  {
                    validator: (rule, value) => {
                      if (value) {
                        const trimmedValue = value.trim();
                        if (
                          shiftList.some(
                            (data) => data.shifttitle === trimmedValue
                          )
                        ) {
                          return Promise.reject("Shift name already exists");
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  placeholder="Shift Title"
                  maxLength={15}
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z0-9\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>

              <Form.Item
                label=""
                name="color"
                rules={[{ required: false, message: "Please select a color" }]}
              >
                <div
                  className="color-box "
                  style={{
                    backgroundColor: titleColor,
                    width: "35px",
                    height: "35px",
                    marginTop: "30px",
                    borderRadius: "6px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    border: "1px solid #d9d9d9",
                  }}
                  onClick={() => setIsModalVisible(true)}
                >
                  <EditOutlined />
                </div>
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
              <Form.Item
                label="Shift Code (Max 5 characters)"
                name="shiftcode"
                rules={[
                  {
                    required: true,
                    message: "Please enter shift Code",
                  },
                  {
                    validator: (rule, value) => {
                      if (value) {
                        const trimmedValue = value.trim();
                        if (
                          shiftList.some(
                            (data) => data.shiftcode === trimmedValue
                          )
                        ) {
                          return Promise.reject("Shift code already exists");
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  maxLength={5}
                  placeholder="Shift Code"
                  onKeyDown={(e) => {
                    const allowedChars = /^[a-zA-Z0-9\s]+$/;
                    if (!allowedChars.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
              <Form.Item
                label="Starts"
                name="starts"
                rules={[
                  {
                    required: true,
                    message: "Please enter shift start time",
                  },
                ]}
              >
                <TimePicker
                  className="w-100"
                  placeholder="Starts"
                  format="hh:mm A"
                  use12Hours
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
              <Form.Item
                label="Ends"
                name="ends"
                rules={[
                  {
                    required: true,
                    message: "Please enter shift end time",
                  },
                ]}
              >
                <TimePicker
                  className="w-100"
                  placeholder="Ends"
                  format="hh:mm A"
                  use12Hours
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
              <Form.Item
                label="Status"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Please Select Status",
                  },
                ]}
              >
                <Radio.Group
                  placeholder="Radio.Group"
                  getPopupContainer={() => containerRef.current}
                >
                  <Radio value="active">Active</Radio>
                  <Radio value="inactive">Inactive</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
              <Form.Item
                label="Do you want to designate holidays as working days for this shift?"
                name="isholiday"
                rules={[
                  {
                    required: true,
                    message:
                      "Please Radio.Group do you want to designate holidays as working days for this shift?",
                  },
                ]}
              >
                <Radio.Group
                  placeholder="Radio.Group"
                  getPopupContainer={() => containerRef.current}
                  onChange={(e) =>
                    e.target.value === "no" ? null : showConfirm(e)
                  }
                >
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12} ref={containerRef}>
              <Form.Item
                label="Weekends for this shift"
                name="isweekend"
                rules={[
                  {
                    required: true,
                    message: "Please Radio.Group weekend for this shift?",
                  },
                ]}
              >
                <Radio.Group
                  placeholder="Radio.Group"
                  getPopupContainer={() => containerRef.current}
                  direction="vertical"
                >
                  <Space direction="vertical">
                    <Radio value="allsaturdayandsunday">
                      All Saturdays and Sundays
                    </Radio>
                    <Radio value="allsaturdays">All Saturdays</Radio>
                    <Radio value="allsundays">All Sundays</Radio>
                    <Radio value="alldays">All Days</Radio>
                    <Radio value="noweekends">No Weekends</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <div className="align-right">
            <StyledButton type="primary" onClick={() => form.resetFields()}>
              Reset
            </StyledButton>
            <StyledButton loading={loader} type="primary" htmlType="submit">
              {loader ? "Next" : "Next"}
            </StyledButton>
          </div>
        </Form>
      )}
      {/* {step === 1 && (
        <>
          {departmentList?.length > 0 && (
            <Checkbox
              className="mt-3"
              checked={selectAllDepartmentChecked}
              onChange={handleSelectAllDepartment}
            >
              Select All
            </Checkbox>
          )}

          <SelectTable
            step={step}
            setStep={setStep}
            columns={departmentcolumns}
            tabledata={departmentList}
            setOpenModal={() => setOpenDepartmentModal(true)}
            Name="Add Department"
          />
          <FormModal
            isModalVisible={openDepartmentModal}
            closeModal={() => setOpenDepartmentModal(false)}
            Name="Department"
          />
        </>
      )}
      {step === 2 && (
        <>
          {filterLocationList?.length > 0 && (
            <Checkbox
              className="mt-3"
              checked={selectAllChecked}
              onChange={handleSelectAllLocation}
            >
              Select All
            </Checkbox>
          )}

          <SelectTable
            step={step}
            setStep={setStep}
            columns={locatincolumns}
            tabledata={filterLocationList}
            setOpenModal={() => setOpenLocationModal(true)}
            Name="Add Location"
          />
          <FormModal
            isModalVisible={openLocationModal}
            closeModal={() => setOpenLocationModal(false)}
            Name="Location"
          />
        </>
      )} */}
      {step === 1 && (
        <InReview
          step={step}
          setStep={setStep}
          BasicInformation={{
            "Shift Title": formValues?.shifttitle,
            "Shift Code": formValues?.shiftcode,
            Starts: dayjs(formValues?.starts).format("hh:mm A"),
            Ends: dayjs(formValues?.ends).format("hh:mm A"),
            Status: formValues?.status === "active" ? "Active" : "Inactive",
            "Holiday - Working Day":
              formValues?.isholiday === "yes" ? "Yes" : "No",
            Weekend: weekendOptions?.find(
              (val) => val?.value === formValues?.isweekend
            )?.label,
          }}
          department={selectDepartmentId}
          location={selectedLocationId}
          create={onFinish}
          loading={loader}
        />
      )}
      <StyledModal
        title="Choose a colour for Shift"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        width={400}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setSelectedColor(titleColor);
              setIsModalVisible(false);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="choose"
            type="primary"
            onClick={() => {
              setTitleColor(selectedColor);
              setIsModalVisible(false);
            }}
          >
            Choose
          </Button>,
        ]}
      >
        <div className="color-grid">
          {colors.map((color) => {
            const isDisabled = shiftColors?.includes(color);

            return (
              <div
                key={color}
                className={`circle ${color === selectedColor ? "active" : ""} ${
                  isDisabled ? "disabled" : ""
                }`}
                style={{
                  backgroundColor: color,
                  opacity: isDisabled ? 0.4 : 1,
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  pointerEvents: isDisabled ? "none" : "auto", // prevents click
                }}
                onClick={() => {
                  if (!isDisabled) {
                    setSelectedColor(color);
                  }
                }}
              >
                {(color === selectedColor || shiftColors?.includes(color)) && (
                  <span className="tick">✓</span>
                )}
              </div>
            );
          })}
        </div>
        <div
          style={{
            border: "1px dashed #d9d9d9",
            padding: "10px",
            borderRadius: "6px",
          }}
        >
          <label>Preview:</label>
          <div
            className="preview-box"
            style={{ backgroundColor: selectedColor }}
          >
            {form.getFieldValue("shifttitle") || "Shift Name"}
          </div>
        </div>
      </StyledModal>
    </div>
  );
};

export default AddShift;
